import { defineAsyncComponent } from '../compat/vueCompat';
import type { MultiItemUsageRestrictionWarningDialogRequest } from './multiItemUsageRestrictionWarningDialogRequest';
import { requestDialog } from './requestDialog';

const MultiItemUsageRestrictionWarningDialog = defineAsyncComponent(() => import('@mimir/web/pages/item/components/MultiItemUsageRestrictionWarningDialog.vue'));

export function showMultiItemUsageRestrictionWarningDialog(req: MultiItemUsageRestrictionWarningDialogRequest) {
  requestDialog(req, MultiItemUsageRestrictionWarningDialog);
}
